/* global angular:false */

(function () {
    "use strict";

    angular.module("vendd")
        .controller('CheckoutCouponController', function ($scope, $q, $element, ControlService, CommonUtils, Validation) {
            $scope.Model = $scope.Model || {};
            $scope.Control = $scope.Control || {};

            var controlName = 'Coupon';
            $scope.registerControl(controlName, $element.get(0));

            $scope.Control.Loading = false;
            $scope.Control.Coupon = '';
            $scope.Control.Submitted = false;
            $scope.Control.IsValid = true;
            $scope.Control.ResultMessage = '';
            $scope.Control.Result = '';
            $scope.Control.CouponRequired = false;
            $element.get(0).focus = function () {
                $('input[ng-model="Control.Coupon"]', $element).focus().select();
            };

            $scope.Control.setCoupon = function ($event) {

                var $thisCoupon = angular.element($event.target);
                var $couponCode = $thisCoupon.attr('data-code');

                $scope.Control.Coupon = $couponCode;

                $scope.Control.submit();
            };

            $scope.Control.submit = function () {
                if (!$scope.Control.Coupon || $scope.Control.Coupon.trim() == '') {
                    $scope.Control.CouponRequired = true;
                    return;
                }
                $scope.Control.CouponRequired = false;
                $scope.Control.Loading = true;

                var submittedCouponName = $scope.Control.Coupon;

                var deferred = $q.defer();

                ControlService.invokeCheckout($scope, $element, 'SetCoupon', $scope.Control.Coupon).then(function (response) {
                    var result = jQuery.parseJSON(response);

                    $scope.Control.IsValid = result.Success;
                    $scope.Control.Result = result.Code;
                    $scope.Control.ResultMessage = jQuery.parseJSON(result.Data).Message;

                    $scope.setControlValue(controlName, $scope.Control.Coupon);

                    $scope.Control.reloadOrder(deferred);

                    $scope.Control.Loading = false;

                    if ($scope.Control.IsValid) {
                        $scope.Control.Submitted = false;
                        $scope.Control.Coupon = '';
                        setTimeout(function () {
                            $.fancybox.close();
                        }, 800);
                        /* Track Discount Coupon */
                        if (typeof fbPixelTracker !== 'undefined' && typeof fbPixelCanTrack !== 'undefined') {
                            if (fbPixelTracker && fbPixelTracker.Properties.FacebookPixelId && fbPixelCanTrack) {
                                fbq('trackCustom', 'DiscountCoupon', { discount: submittedCouponName });
                            }
                        } 
                        /* END Track Discount Coupon */
                    } else {
                        $scope.Control.Submitted = true;
                    }

                }, function (ex) {
                    console.log(ex);
                    $scope.Control.Submitted = true;
                    $scope.Control.Loading = false;
                    $scope.Control.IsValid = false;
                    $scope.Control.Result = 'CartCoupon_GenericError';
                    $scope.Control.ResultMessage = jQuery.parseJSON(result.Data).Message;

                    $scope.setControlValue(controlName, '');

                    $scope.Control.reloadOrder(deferred);

                    $scope.Control.Loading = false;
                });

                return deferred.promise;
            };

            $scope.Control.clear = function (code) {
                if (code == '')  return;

                $scope.Control.Loading = true;

                var deferred = $q.defer();

                ControlService.invokeCheckout($scope, $element, 'ClearCoupon', code).then(function (response) {
                    var result = jQuery.parseJSON(response);

                    $scope.Control.Coupon = '';
                    $scope.Control.Submitted = false;
                    $scope.Control.IsValid = true;
                    $scope.Control.Result = '';
                    $scope.Control.ResultMessage = jQuery.parseJSON(result.Data).Message;

                    $scope.Control.reloadOrder(deferred);

                    $scope.Control.Loading = false;
                }, function (error) {
                    $scope.Control.Coupon = '';
                    $scope.Control.Submitted = false;
                    $scope.Control.IsValid = false;
                    $scope.Control.Result = '';
                    $scope.Control.ResultMessage = jQuery.parseJSON(result.Data).Message;

                    $scope.Control.reloadOrder(deferred);

                    $scope.Control.Loading = false;
                });

                return deferred.promise;
            };

            $scope.Control.clearAll = function () {
                if ($scope.$parent.Order.Current.Coupons.length == 0)
                    return;

                $scope.Control.Loading = true;

                var deferred = $q.defer();

                ControlService.invokeCheckout($scope, $element, 'ClearCoupons', []).then(function (response) {
                    var result = jQuery.parseJSON(response);

                    $scope.Control.Coupon = '';
                    $scope.Control.Submitted = false;
                    $scope.Control.IsValid = true;
                    $scope.Control.Result = '';
                    $scope.Control.ResultMessage = jQuery.parseJSON(result.Data).Message;

                    $scope.Control.reloadOrder(deferred);

                    $scope.Control.Loading = false;
                }, function (error) {
                    $scope.Control.Coupon = '';
                    $scope.Control.Submitted = false;
                    $scope.Control.IsValid = false;
                    $scope.Control.Result = '';
                    $scope.Control.ResultMessage = jQuery.parseJSON(result.Data).Message;

                    $scope.Control.reloadOrder(deferred);

                    $scope.Control.Loading = false;
                });

                return deferred.promise;
            };

            $scope.Control.reloadOrder = function (deferred) {
                if ($scope['Order'] && $scope['Order'].Wrapper && typeof ($scope['Order'].Wrapper.reload) == 'function') {
                    $scope['Order'].Wrapper.reload().then(function (orderResponse) {
                        if ($('.x-checkoutshippingaddress').scope().Config.IsExplicitTimeslotEnabled) {
                            $('.x-checkoutorderexplicittimeslot').get(0).reload();
                        }

                        if ($scope['ShippingMethod'] && $scope['ShippingMethod'].Wrapper && typeof ($scope['ShippingMethod'].Wrapper.reload) == 'function') {
                            $scope['ShippingMethod'].Wrapper.reload().then(function (smresponse) {
                                if ($scope['PaymentMethod'] && $scope['PaymentMethod'].Wrapper && typeof ($scope['PaymentMethod'].Wrapper.reload) == 'function') {
                                    $scope['PaymentMethod'].Wrapper.reload().then(function (bmresponse) {
                                        deferred.resolve();
                                        $scope.Control.Loading = false;
                                    }, function (bmerror) {
                                        deferred.reject(bmerror);
                                        $scope.Control.Loading = false;
                                    });
                                } else {
                                    deferred.resolve();
                                    $scope.Control.Loading = false;
                                }
                            }, function (smerror) {
                                deferred.reject(smerror);
                                $scope.Control.Loading = false;
                            });
                        } else {
                            deferred.resolve();
                            $scope.Control.Loading = false;
                        }
                    }, function (orderError) {
                        deferred.reject(orderError);
                        $scope.Control.Loading = false;
                    });
                } else {
                    deferred.resolve();
                    $scope.Control.Loading = false;
                }

                return deferred.promise;
            };

            if (checkoutOverrides && checkoutOverrides.Coupon && typeof checkoutOverrides.Coupon.Extend === 'function') {
                $scope = checkoutOverrides.Coupon.Extend($scope, $element);
            }

            ControlService.getCheckoutData("GetCouponData", $scope, $element).then(function (response) {
                $scope.Model = {};
                angular.extend($scope.Model, response);
                if (checkoutOverrides && checkoutOverrides.Coupon && typeof checkoutOverrides.Coupon.OnGetData === 'function') {
                    checkoutOverrides.Coupon.OnGetData($scope);
                }
                $scope.Control.Loading = false;
            }, function (error) {
                $scope.Control.Loading = false;
                throw error;
            });

        });
})();